import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Form, Image } from 'react-bootstrap';
import { useAuth } from './../../../context/AuthContext';
import { toast } from 'react-toastify';
import { sendEmailVerification } from 'firebase/auth';
import { RotatingLines } from 'react-loader-spinner';
import logo from "../../../assets/logo/on9estate-vertical-logo.png";

const Login = () => {

  const { login } = useAuth();
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState({
    email: '',
    password: '',
  });
  const [errorInput, setErrorInput] = useState({});

  const handleLogin = async (event) => {
    event.preventDefault();

    setIsLoading(true);
    if (data.email && data.password) {
      login(data.email, data.password).then((response) => {
        if (response && response.user && !response.user.emailVerified) {
          sendEmailVerification(response.user)
            .then(() => {
              setIsLoading(false);
              navigate('/setup-profile');
            });
        }
      }).catch((error) => {
        if (error.code === 'auth/user-not-found') {
          toast.error('User not found!');
        }
        if (error.code === 'auth/wrong-password') {
          toast.error('Wrong password!');
        }
        if (error.code === 'auth/too-many-requests') {
          toast.error('Too many attempts, Please try again later!');
        }
        setIsLoading(false);
      });
    } else {
      if (!data.email) {
        setErrorInput({ ...errorInput, email: 'Enter your email' });
      } else if (!data.password) {
        setErrorInput({ ...errorInput, password: 'Enter your password' });
      }
      setIsLoading(false);
    }
  }

  return (
    <div className='h-100vh'>
      <div className='container'>
        <div className='row align-items-center justify-content-around'>
          <div className='col-md-5 col-lg-4 py-5 my-5'>
            <div className='bg-white border-0 mb-0 card custom-shadow'>
              <div className='p-3'>
                <div className='d-flex align-items-center justify-content-center py-4 border-bottom'>
                  <Image src={logo} className="img-fluid" width={160} height={100} />
                </div>
                <h4 className="text-center mt-3">Login</h4>
              </div>
              <div className='p-md-4 m-md-1 p-3 pb-5'>
                <Form onSubmit={handleLogin}>
                  {
                    errorInput && errorInput.other ?
                      <div className='input-error mb-3 text-center'>{errorInput.other}</div>
                      :
                      null
                  }
                  <Form.Group className="mb-3" controlId="formEmail">
                    <Form.Control
                      type="email"
                      placeholder="Email"
                      onChange={(e) => {
                        setData({
                          ...data,
                          email: e.target.value,
                        });
                        setErrorInput({ ...errorInput, email: '' })
                      }}
                      className={errorInput.email ? 'border-danger' : null}
                      value={data.email}
                      isInvalid={errorInput.email}
                    />
                    <Form.Control.Feedback type="invalid">{errorInput.email}</Form.Control.Feedback>
                  </Form.Group>

                  <Form.Group className="mb-4" controlId="formPassword">
                    <Form.Control
                      type="password"
                      placeholder="Password"
                      onChange={(e) => {
                        setData({
                          ...data,
                          password: e.target.value,
                        });
                        setErrorInput({ ...errorInput, password: '' })
                      }}
                      className={errorInput.password ? 'border-danger' : null}
                      value={data.password}
                      isInvalid={errorInput.password}
                    />
                    <Form.Control.Feedback type="invalid">{errorInput.password}</Form.Control.Feedback>
                  </Form.Group>
                  <div className='d-flex align-item-center justify-content-center'>
                    <Button disabled={isLoading && isLoading} variant="primary" className='w-100' type="submit">
                      {
                        isLoading ?
                          <RotatingLines
                            visible={isLoading}
                            height="24"
                            width="24"
                            strokeColor="white"
                            animationDuration="1"
                          />
                          :
                          "Login"
                      }
                    </Button>
                  </div>
                  <div className='mt-4 d-flex justify-content-center align-items-center'>
                    <div className='forgot-password-link'>
                      <a href="/forgot-password">Forgot your password?</a>
                    </div>
                  </div>
                </Form>
              </div>
              <hr className='border-info m-0' />
              <div className='p-4'>
                <div className='text-center mb-3'>
                  <p>Design & Developed By <a href="https://www.appzito.com">Appzito Technologies</a></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Login;